import { render, staticRenderFns } from "./UserHandle.vue?vue&type=template&id=6c3eec2b&scoped=true&"
import script from "./UserHandle.vue?vue&type=script&lang=js&"
export * from "./UserHandle.vue?vue&type=script&lang=js&"
import style0 from "./UserHandle.vue?vue&type=style&index=0&id=6c3eec2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3eec2b",
  null
  
)

export default component.exports